import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="test-script--failure-reason"

// This controller is used to enable the failure reason input field when the minor defect check box is selected.
// Test result = Failed -> Minor Defect is disabled & Failure reason is enabled
// Test result = Passed -> Minor Defect is enabled & Failure reason is disabled
// Test result = Passes with minor defects -> Failure reason is enabled
export default class extends Controller {
  static targets = ['code', 'failed', 'minor', 'passed', 'data']

  // Fires on page load and again when an inline-edit turbo frame swaps the
  // fields in — connect() alone would miss the latter (#1383)
  failedTargetConnected (target) {
    if (target.checked) {
      this.hideData()
    }
  }

  failed () {
    // disable and uncheck the minor defect checkbox
    this.disableMinor()
    // enable the failure reason input field
    this.enableCode()
    this.hideData()
  }

  minor () {
    if (this.minorTarget.checked) {
      this.enableCode()
    } else {
      this.disableCode()
    }
  }

  passed () {
    if (this.codeTarget.value) {
      this.minorTarget.checked = true
      this.enableCode()
    } else {
      this.disableCode()
    }
    this.enableMinor()
    this.showData()
  }

  disableCode () {
    if (this.codeTarget.tomselect) {
      this.codeTarget.tomselect.clear()
      this.codeTarget.tomselect.disable()
    } else {
      this.codeTarget.value = ''
      this.codeTarget.disabled = true
    }
  }

  enableCode () {
    if (this.codeTarget.tomselect) {
      this.codeTarget.tomselect.enable()
    } else {
      this.codeTarget.disabled = false
    }
  }

  disableMinor () {
    this.minorTarget.disabled = true
    this.minorTarget.checked = false
  }

  enableMinor () {
    this.minorTarget.disabled = false
  }

  // The recorded-data section only exists on the full form, not in the inline
  // edit frame, so the target is optional
  showData () {
    if (this.hasDataTarget) this.dataTarget.classList.remove('hidden')
  }

  hideData () {
    if (this.hasDataTarget) this.dataTarget.classList.add('hidden')
  }
}
